export default "__VITE_ASSET__CGplEW0P__"